import { RegvarModel } from './index';
export class RegvarStringModel extends RegvarModel {
    setValue(value, options) {
        let newVal = value;
        // Guard ifall man inte använder TS. Tex om ett nummer skickas in.
        if (newVal) {
            newVal = newVal.toString();
        }
        return super.setValue(newVal, options);
    }
}
